// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir] .wrapper--BX5L3 {
  padding: 30px 60px;
}

.scoreBar--X5Ffe {
  height: 35px;
  width: 92%;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/MapLegend/subComponents/ScoreLegend/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ","sourcesContent":[".wrapper {\n  padding: 30px 60px;\n}\n\n.scoreBar {\n  height: 35px;\n  width: 92%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper--BX5L3`,
	"scoreBar": `scoreBar--X5Ffe`
};
export default ___CSS_LOADER_EXPORT___;
